import React from 'react';
import Big from 'big.js';
import { OrderBookRowFieldProps } from '../../../types';

export const OrderBookSideAmount = (props: OrderBookRowFieldProps) => {
  return new Big(props.metric.amount).toPrecision(5);
};

export default OrderBookSideAmount;
